







































import {Component, Vue} from 'vue-property-decorator';
import {mapActions, mapState} from 'vuex';
import PlanEditModel, {SolveModel} from '@/models/PlanEditModel';
import CAlertDialog from '@/components/base/dialog/CAlertDialog.vue';

@Component({
    components: {CAlertDialog},
    computed: {
        ...mapState('planEdit', ['planEdit', 'solve', 'disabledTabs']),
    },
    methods: {
        ...mapActions('planEdit', ['solveRun', 'solveCancel', 'approvePlan', 'disapprovePlan']),
    },
})
export default class PlanEditMainCard extends Vue {
    public planEdit!: PlanEditModel | null;
    public solve!: SolveModel | null;
    public solveRun!: Function;
    public solveCancel!: Function;
    public approvePlan!: Function;
    public disapprovePlan!: Function;
    public disabledTabs!: boolean;

    get solveBtnText() {
        return this.solve?.IsFinalState ? this.$t('Common.Calculate') : this.$t('Common.Cancel');
    }

    get solveBtnColor() {
        return this.solve?.IsFinalState ? 'primary' : 'error';
    }

    get approvedBtnText() {
        return this.planEdit?.IsApproved ? 'Отклонить' : 'Утвердить';
    }

    get approvedBtnColor() {
        return this.planEdit?.IsApproved ? 'error' : 'primary';
    }

    get disableApprovedButton() {
        return !this.planEdit?.IdLastPlanRes || !this.solve?.IsFinalState || this.disabledTabs;
    }

    onSolve() {
        if (this.planEdit?.IsApproved) return;
        return this.solve?.IsFinalState ? this.solveRun(this.planEdit?.Id) : this.solveCancel(this.planEdit?.Id);
    }

    onApproved() {
        if (this.disableApprovedButton) return;
        if (this.planEdit?.IsApproved) {
            this.disapprovePlan(this.planEdit?.Id).catch((e: any) => this.showApproveError(e));
        } else {
            this.approvePlan(this.planEdit?.Id).catch((e: any) => this.showApproveError(e));
        }
    }

    showApproveError(e: any) {
        const msg = e?.response?.data?.errors?.id[0],
            dialog = this.$refs.alertDialog as any;
        if (msg) dialog.open(msg);
    }
}
